<template>
  <div>
    <v-container fluid>
      <v-card>
        <v-app-bar color="primary" flat dark dense>
          <v-toolbar-title>Fornecedores</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn
            depressed
            fab
            small
            color="primary lighten-5"
            class="mr-2"
            @click="$refs.dialogoImpressaoListagem.abrir()"
            ><v-icon>print</v-icon></v-btn
          >
          <v-btn
            depressed
            fab
            small
            @click="tooglePesquisa"
            color="primary lighten-5"
          >
            <v-icon>search</v-icon>
          </v-btn>
          <!-- <v-btn
            text
            @click="$router.push('/fornecedores/adicionar')"
            class="hidden-xs-only"
            v-if="user.tipo == 'administrador'"
            >Adicionar</v-btn
          >
          <v-btn
            icon
            @click="$router.push('/fornecedores/adicionar')"
            class="hidden-sm-and-up"
            v-if="user.tipo == 'administrador'"
            ><v-icon>add</v-icon></v-btn
          > -->
        </v-app-bar>

        <v-expand-transition>
          <v-row dense v-show="exibirPesquisa" class="pa-2">
            <v-col cols="12" pa-2>
              <v-text-field
                ref="pesquisa"
                label="Pesquisa"
                v-model="pesquisa"
                prepend-inner-icon="search"
                solo
                background-color="grey lighten-2"
                clearable
                single-line
                hide-details
                placeholder="Pesquisa"
                color="primary"
                @click:clear="tooglePesquisa"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-expand-transition>

        <v-divider />

        <v-data-table
          :search="pesquisa"
          :headers="headers"
          :items="fornecedores"
          :loading="loading"
          :footer-props="{
            itemsPerPageOptions: [10, 30, 50, { text: 'Todos', value: -1 }],
            itemsPerPageText: 'Registros Exibidos',
          }"
          :items-per-page="30"
          no-data-text="Sem registros"
          no-results-text="Sem registros"
          loading-text="Carregando dados..."
        >
          <template v-slot:items="{ item: fornecedor }">
            <td>
              {{ fornecedor.nome_fantasia }}
              <v-chip
                label
                color="lightgray"
                small
                v-if="fornecedor.ativo == 0"
                class="pa-0"
                >Desativado</v-chip
              >
            </td>
            <td class="hidden-xs-only">{{ fornecedor.razao_social }}</td>
            <td class="hidden-xs-only">{{ fornecedor.cnpj }}</td>
            <td>{{ fornecedor.local }}</td>
          </template>
          <template v-slot:item.opcoes="{ item }">
            <v-menu bottom left>
              <template v-slot:activator="{ on }">
                <v-btn icon v-on="on">
                  <v-icon>more_vert</v-icon>
                </v-btn>
              </template>

              <v-list dense>
                <!-- <v-list-item
                  @click="
                    $router.push(
                      'fornecedores/' + item.fornecedor.id + '/editar'
                    )
                  "
                >
                  <v-list-item-title>
                    <v-icon>edit</v-icon> Editar
                  </v-list-item-title>
                </v-list-item>
                <v-list-item @click="abrirDialogoExcluir(item.fornecedor)">
                  <v-list-item-title>
                    <v-icon>close</v-icon> Excluir
                  </v-list-item-title>
                </v-list-item>
                <v-list-item @click="abrirDialogoResetar(item.fornecedor)">
                  <v-list-item-title>
                    <v-icon>lock_open </v-icon> Resetar Senha
                  </v-list-item-title>
                </v-list-item>
                <v-list-item
                  @click="abrirDialogoAtivacao(item.fornecedor)"
                  v-if="fornecedor.ativo"
                >
                  <v-list-item-title>
                    <v-icon>block</v-icon> Desativar
                  </v-list-item-title>
                </v-list-item>
                <v-list-item
                  @click="abrirDialogoAtivacao(item.fornecedor)"
                  v-else
                >
                  <v-list-item-title>
                    <v-icon>done</v-icon> Ativar
                  </v-list-item-title>
                </v-list-item>
                <v-list-item @click="abrirDialogoExcluir(item.fornecedor)">
                  <v-list-item-title>
                    <v-icon>close</v-icon> Excluir
                  </v-list-item-title>
                </v-list-item> -->
                <v-list-item @click="abrirDialogoFornecedor(item)">
                  <v-list-item-title>
                    <v-icon class="pr-4">list_alt</v-icon>Detalhes
                  </v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </template>
        </v-data-table>
      </v-card>

      <as-dialogo
        ref="dialogoExcluir"
        title="Excluir Fornecedor"
        max-width="440px"
        hideCloseButton
      >
        <p>Deseja excluir este fornecedor?</p>
        <div slot="botoes">
          <v-btn color="white" @click="$refs.dialogoExcluir.fechar()"
            >Cancelar</v-btn
          >
          <v-btn
            color="error"
            @click="excluir"
            :disabled="excluindo"
            :loading="excluindo"
            >Excluir</v-btn
          >
        </div>
      </as-dialogo>

      <as-dialogo
        ref="dialogoResetar"
        title="Resetar Senha"
        max-width="440px"
        hideCloseButton
      >
        <p>Deseja resetar a senha deste fornecedor?</p>
        <span>OBS: A senha será redefinida para <b>123456</b></span>
        <div slot="botoes">
          <v-btn color="white" @click="$refs.dialogoResetar.fechar()"
            >Cancelar</v-btn
          >
          <v-btn
            color="error"
            @click="resetar"
            :disabled="resetando"
            :loading="resetando"
            >Resetar</v-btn
          >
        </div>
      </as-dialogo>

      <as-dialogo
        ref="dialogoAtivacao"
        :title="fornecedor.ativo ? 'Desativar Fornecedor' : 'Ativar Fornecedor'"
        max-width="440px"
        hideCloseButton
      >
        <p>
          Deseja confirmar a <span v-if="fornecedor.ativo == 0">ativação</span>
          <span v-else>desativação</span> deste fornecedor?
        </p>
        <span v-if="fornecedor.ativo == 1"
          >OBS: Esta ação impossibilitará o fornecedor de fazer login até que
          você resete sua senha ou ative-o novamente</span
        >
        <div slot="botoes">
          <v-btn color="white" @click="$refs.dialogoAtivacao.fechar()"
            >Cancelar</v-btn
          >
          <!-- <v-btn color="error" @click="bloquear" :disabled="bloqueando" :loading="bloqueando">Bloquear</v-btn> -->
          <v-btn
            color="primary"
            @click="bloquear"
            :disabled="bloqueando"
            :loading="bloqueando"
            v-if="fornecedor.ativo == 0"
            >Ativar</v-btn
          >
          <v-btn
            color="primary"
            @click="bloquear"
            :disabled="bloqueando"
            :loading="bloqueando"
            v-else
            >Desativar</v-btn
          >
        </div>
      </as-dialogo>

      <as-dialogo
        ref="dialogoImpressaoListagem"
        title="Imprimir"
        max-width="440px"
        hideCloseButton
      >
        <v-label>Deseja imprimir a listagem de fornecedores?</v-label>
        <div class="pt-8" style="display: flex; justify-content: flex-end;">
          <v-btn
            depressed
            class="mr-4"
            @click="$refs.dialogoImpressaoListagem.fechar()"
            >Cancelar</v-btn
          >
          <v-btn
            depressed
            color="primary"
            @click="imprimirListagem"
            :disabled="imprimindo"
            :loading="imprimindo"
            >Imprimir</v-btn
          >
        </div>
      </as-dialogo>
    </v-container>

    <as-dialogo
      ref="dialogoFornecedor"
      title="Detalhes do Fornecedor"
      max-width="960px"
    >
      <v-form>
        <v-row dense>
          <v-col cols="12" sm="6">
            <v-text-field
              label="Nome Fantasia"
              v-model="fornecedor.nome_fantasia"
              hide-details
              readonly
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6">
            <v-text-field
              label="Razão Social"
              v-model="fornecedor.razao_social"
              hide-details
              readonly
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col cols="12" sm="6">
            <v-text-field
              label="CNPJ"
              v-model="fornecedor.cnpj"
              hide-details
              readonly
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6">
            <v-text-field
              label="Inscrição Estadual"
              v-model="fornecedor.ie"
              hide-details
              readonly
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col cols="12" sm="5">
            <v-text-field
              label="Rua"
              v-model="fornecedor.endereco.rua"
              hide-details
              readonly
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="3">
            <v-text-field
              label="Número"
              v-model="fornecedor.endereco.numero"
              hide-details
              readonly
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="4">
            <v-text-field
              label="Complemento"
              v-model="fornecedor.endereco.complemento"
              hide-details
              readonly
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col cols="12" sm="4">
            <v-text-field
              label="Bairro"
              v-model="fornecedor.endereco.bairro"
              hide-details
              readonly
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="5">
            <v-text-field
              label="Cidade / Estado"
              v-model="fornecedor.local"
              hide-details
              readonly
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="3">
            <v-text-field
              label="CEP"
              v-model="fornecedor.endereco.cep"
              hide-details
              readonly
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col cols="12" sm="4">
            <v-text-field
              label="Telefone"
              v-model="fornecedor.endereco.telefone"
              hide-details
              readonly
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="4">
            <v-text-field
              label="Celular"
              v-model="fornecedor.endereco.celular"
              hide-details
              readonly
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="4">
            <v-text-field
              label="Email"
              v-model="fornecedor.endereco.email"
              hide-details
              readonly
            ></v-text-field>
          </v-col>
        </v-row>
      </v-form>

      <v-divider class="mt-4" v-if="user.tipo == 'representante'" />
      <v-row dense v-if="user.tipo == 'representante'">
        <v-col sm="6">
          <h3 class="mt-4">Avaliação dos Representantes</h3>
        </v-col>
        <v-col sm="6">
          <v-btn
            depressed
            color="primary"
            @click="$refs.dialogoAvaliacaoRepresentante.abrir()"
            class="white--text mt-2 float-right"
            >Nova avaliação</v-btn
          >
        </v-col>
      </v-row>

      <v-list dense v-if="user.tipo == 'representante'">
        <v-divider />
        <v-row v-if="carregando_avaliacoes">
          <v-col
            class="ma-4 pa-4"
            style="display: flex; align-items: center; justify-content: center; text-align: center"
          >
            <v-progress-circular
              size="64"
              indeterminate
              color="primary"
            ></v-progress-circular>
          </v-col>
        </v-row>

        <template v-else>
          <v-list-item-group
            color="primary"
            style="max-height: 30vh; overflow: scroll;"
          >
            <v-list-item v-for="(item, i) in avaliacoes" :key="i" class="pa-0">
              <v-list-item-icon style="width: 120px">
                <v-rating
                  v-model="item.rating"
                  background-color="white"
                  dense
                  class="pt-1 pl-2"
                  color="primary accent-4"
                  :readonly="true"
                  half-increments
                  size="18"
                />
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title v-html="item.comentario"></v-list-item-title>
                <v-list-item-subtitle
                  class="red--text caption"
                  style="text-transform: capitalize"
                >
                  {{
                    tempoAvaliacao(item.created_at) +
                      " - " +
                      item.representante.nome_fantasia
                  }}
                </v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-action class="ma-0">
                <v-btn
                  fab
                  small
                  depressed
                  class="mr-1"
                  v-if="item.representante_id == user.representante_id"
                  @click="abrirDialogoExcluirAvaliacao(item)"
                >
                  <v-icon>delete</v-icon>
                </v-btn>
              </v-list-item-action>
            </v-list-item>
            <v-list-item
              v-if="countAvaliacoes"
              class="justify-center text-center pt-4"
              background-color="white"
            >
              <v-label>Nenhuma avaliação encontrada!</v-label>
            </v-list-item>
          </v-list-item-group>
        </template>
      </v-list>

      <template
        v-slot:botoes_esquerda
        v-if="!carregando_avaliacoes && user.tipo == 'representante'"
      >
        <v-btn
          color="primary"
          v-if="fornecedor.ativo_representante == 1"
          @click="abrirDialogoAtivarDesativar(0)"
          >Desativar</v-btn
        >
        <v-btn color="primary" v-else @click="abrirDialogoAtivarDesativar(1)"
          >Ativar</v-btn
        >
      </template>
    </as-dialogo>

    <as-dialogo
      ref="dialogoAvaliacaoRepresentante"
      title="Avaliar Fornecedor"
      max-width="620px"
      hideCloseButton
      hideDivider
    >
      <v-form
        ref="form_avaliacao"
        v-model="form_valid_avaliacao"
        lazy-validation
      >
        <v-row dense>
          <v-col sm="5">
            <h2 class="mt-2">Avaliação</h2>
          </v-col>
          <v-col sm="7">
            <v-input
              :value="avaliacao.rating"
              :rules="rulesForm.rating"
              hideDetails
            >
              <v-rating
                class="ml-auto"
                background-color="#ccc"
                color="primary accent-4"
                half-increments
                hover
                v-model="avaliacao.rating"
              ></v-rating>
            </v-input>
          </v-col>

          <v-col sm="12">
            <v-textarea
              label="Comentário"
              :rules="rulesForm.comentario"
              v-model="avaliacao.comentario"
              hideDetails
            ></v-textarea>
          </v-col>
        </v-row>
      </v-form>
      <div slot="botoes">
        <v-btn
          depressed
          class="mr-4"
          @click="$refs.dialogoAvaliacaoRepresentante.fechar()"
          >Cancelar</v-btn
        >
        <v-btn
          depressed
          color="primary"
          @click="salvarAvaliacaoRepresentante"
          :disabled="!form_valid_avaliacao"
          :loading="salvandoAvaliacao"
          >Salvar</v-btn
        >
      </div>
    </as-dialogo>

    <as-dialogo
      ref="dialogoExcluirAvaliacao"
      title="Excluir"
      max-width="440px"
      hideCloseButton
      hideDivider
    >
      <v-label>Deseja realmente excluir essa avaliação?</v-label>
      <div slot="botoes">
        <v-btn
          class="mr-4"
          depressed
          @click="$refs.dialogoExcluirAvaliacao.fechar()"
          >Não</v-btn
        >
        <v-btn
          depressed
          color="primary"
          @click="excluirAvaliacaoRepresentante"
          :loading="excluindoAvaliacao"
          >Sim</v-btn
        >
      </div>
    </as-dialogo>

    <as-dialogo
      ref="dialogoAtivarDesativar"
      title="Ativar/Desativar Fornecedor"
      max-width="440px"
      hideCloseButton
      hideDivider
    >
      <v-label v-if="fornecedor.ativo_representante == 1">
        Deseja realmente desavitar esse fornecedor?
      </v-label>
      <v-label v-else>Deseja realmente ativar esse fornecedor?</v-label>
      <div slot="botoes">
        <v-btn
          class="mr-4"
          depressed
          @click="$refs.dialogoAtivarDesativar.fechar()"
          >Cancelar</v-btn
        >
        <v-btn
          depressed
          color="primary"
          @click="ativarDesativarFornecedor()"
          :loading="loading"
          >Confirmar</v-btn
        >
      </div>
    </as-dialogo>
  </div>
</template>

<script>
import ServiceRepresentantes from "@/services/representantes.js";
import ServiceFornecedores from "@/services/fornecedores.js";
import ServiceImpressoes from "@/services/impressoes.js";
import config from "@/config";
import moment from "moment";

export default {
  name: "fornecedores",
  data() {
    return {
      user: {},
      loading: false,
      excluindo: false,
      resetando: false,
      bloqueando: false,
      carregando_avaliacoes: false,
      salvandoAvaliacao: false,
      excluindoAvaliacao: false,
      form_valid_avaliacao: true,
      fornecedores: [],
      fornecedor: {
        endereco: {
          telefone: "",
        },
      },
      headers: [],
      pesquisa: "",
      exibirPesquisa: false,
      imprimindo: false,
      avaliacoes: [],
      rulesForm: {
        rating: [(value) => !!value || "Campo Obrigatório"],
        comentario: [(value) => !!value || "Campo Obrigatório"],
      },
      avaliacao: {
        rating: 0,
        comentario: "",
      },
      avaliacaoSelecionada: null,
      status: null,
    };
  },
  mounted() {
    this.user = JSON.parse(localStorage.getItem("user"));
    if (this.user.tipo == "administrador") {
      this.headers = [
        { text: "Nome Fantasia", value: "nome_fantasia", width: "25%" },
        {
          text: "Razão Social",
          value: "razao_social",
          width: "25%",
          class: "hidden-xs-only",
        },
        { text: "CNPJ", value: "cnpj", width: "20%", class: "hidden-xs-only" },
        { text: "Cidade", value: "local", width: "20%" },
        {
          text: "",
          value: "opcoes",
          width: "5%",
          sortable: false,
          align: "center",
        },
      ];
    } else {
      this.headers = [
        { text: "Nome Fantasia", value: "nome_fantasia", width: "25%" },
        {
          text: "Razão Social",
          value: "razao_social",
          width: "25%",
          class: "hidden-xs-only",
        },
        { text: "CNPJ", value: "cnpj", width: "20%", class: "hidden-xs-only" },
        { text: "Cidade", value: "local", width: "20%", align: "right" },
        {
          text: "",
          value: "opcoes",
          width: "5%",
          sortable: false,
          align: "center",
        },
      ];
    }
    this.listar();
  },

  methods: {
    async listar() {
      try {
        this.loading = true;
        // let response = await ServiceRepresentantes.listarFornecedores(this.user.representante_id)
        let response = await ServiceFornecedores.listar();
        this.fornecedores = response.data.fornecedores;
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    abrirDialogoExcluir(fornecedor) {
      this.fornecedor = this.clone(fornecedor);
      this.$refs.dialogoExcluir.abrir();
    },
    async excluir() {
      try {
        this.excluindo = true;

        let response = await ServiceFornecedores.excluir(this.fornecedor.id);
        if (response.data.status == 1) {
          this.$eventbus.notificar(response.data.msg);
          this.listar();
        } else if (response.data.status == 2) {
          this.$eventbus.erro(response.data.msg);
        }
      } catch (error) {
        console.log(error);
        this.$eventbus.erro("Erro ao excluir fornecedor");
      } finally {
        this.excluindo = false;
        this.$refs.dialogoExcluir.fechar();
      }
    },
    abrirDialogoExcluirAvaliacao(avaliacao) {
      this.avaliacaoSelecionada = this.clone(avaliacao);
      this.$refs.dialogoExcluirAvaliacao.abrir();
    },
    async excluirAvaliacaoRepresentante() {
      try {
        this.excluindoAvaliacao = true;
        this.$refs.dialogoExcluirAvaliacao.fechar();
        let response = await ServiceFornecedores.excluirAvaliacaoRepresentante(
          this.avaliacaoSelecionada.id
        );
        if (response.data.status == 1) {
          this.$eventbus.notificar(response.data.msg);
          this.listarAvaliacoes();
        } else if (response.data.status == 2) {
          this.$eventbus.erro(response.data.msg);
        }
      } catch (error) {
        console.log(error);
        this.$eventbus.erro("Erro ao excluir avaliação");
      } finally {
        this.excluindoAvaliacao = false;
      }
    },
    async listarAvaliacoes() {
      try {
        this.carregando_avaliacoes = true;
        let response = await ServiceFornecedores.listarAvaliacoes(
          this.fornecedor.id
        );
        this.avaliacoes = response.data.avaliacoes;
        this.fornecedor.ativo_representante = response.data.ativo;
      } catch (error) {
        console.log(error);
      } finally {
        this.carregando_avaliacoes = false;
      }
    },
    async salvarAvaliacaoRepresentante() {
      if (this.$refs.form_avaliacao.validate()) {
        try {
          this.salvandoAvaliacao = true;
          this.$refs.dialogoAvaliacaoRepresentante.fechar();
          this.avaliacao.representante_id = this.user.representante_id;
          this.avaliacao.fornecedor_id = this.fornecedor.id;
          let response = await ServiceFornecedores.salvarAvaliacaoRepresentante(
            this.avaliacao
          );
          if (response.data.status == 1) {
            this.$eventbus.notificar(response.data.msg);
            this.avaliacao = {
              rating: 0,
              comentario: "",
            };
            this.listarAvaliacoes();
          } else if (response.data.status == 2) {
            this.$eventbus.erro(response.data.msg);
          }
        } catch (error) {
          console.log(error);
          this.$eventbus.erro("Erro ao salvar avaliação");
        } finally {
          this.salvandoAvaliacao = false;
        }
      }
    },
    abrirDialogoResetar(fornecedor) {
      this.fornecedor = this.clone(fornecedor);
      this.$refs.dialogoResetar.abrir();
    },
    async resetar() {
      try {
        this.resetando = true;
        await ServiceFornecedores.resetarSenha(this.fornecedor.id);

        this.$eventbus.notificar(
          "Senha resetada com sucesso. Nova senha: 123456"
        );
      } catch (error) {
        console.log(error);
        this.$eventbus.erro("Erro ao resetar a senha deste fornecedor");
      } finally {
        this.resetando = false;
        this.listar();
        this.$refs.dialogoResetar.fechar();
      }
    },
    abrirDialogoAtivacao(fornecedor) {
      this.fornecedor = this.clone(fornecedor);
      this.$refs.dialogoAtivacao.abrir();
    },
    async bloquear() {
      try {
        this.bloqueando = true;
        await ServiceFornecedores.bloquear(this.fornecedor.id);
        this.listar();

        if (this.fornecedor.ativo) {
          this.$eventbus.notificar("Fornecedor desativado com sucesso");
        } else {
          this.$eventbus.notificar("Fornecedor ativado com sucesso");
        }
      } catch (error) {
        this.$eventbus.erro("Erro ao bloquear a conta deste fornecedor");
      } finally {
        this.bloqueando = false;
        this.$refs.dialogoAtivacao.fechar();
      }
    },
    async imprimirListagem() {
      try {
        this.imprimindo = true;
        let impressao = JSON.parse(localStorage.getItem("impressao_remota"))
          ? "remota"
          : "local";
        if (impressao == "local") {
          this.$store.commit("showImprimirPdf", true);
        }
        let pdf = await ServiceImpressoes.listarFornecedores({
          impressao,
          rodada_id: this.$store.state.rodada.id,
        });
        if (impressao == "local") {
          this.$store.commit("setPdfUrl", pdf);
        } else {
          this.$eventbus.notificar(
            "Impressão encaminhada para a Ilha de Impressão com sucesso"
          );
        }
      } catch (error) {
        this.$eventbus.erro("Erro ao imprimir listagem de fornecedores");
      } finally {
        this.imprimindo = false;
        this.$refs.dialogoImpressaoListagem.fechar();
      }
    },
    abrirDialogoFornecedor(fornecedor) {
      this.avaliacoes = [];
      this.fornecedor = fornecedor;
      this.listarAvaliacoes();
      this.$refs.dialogoFornecedor.abrir();
    },
    async ativarDesativarFornecedor() {
      try {
        this.loading = true;
        let response = await ServiceRepresentantes.ativarDesativarFornecedor(
          this.user.representante_id,
          this.fornecedor.id,
          this.status
        );
        this.status = null;
        this.listar();
      } catch (error) {
        console.log(error);
        this.$eventbus.erro("Erro ao ativar/desativar fornecedor");
      } finally {
        this.loading = false;
        this.$refs.dialogoAtivarDesativar.fechar();
        this.$refs.dialogoFornecedor.fechar();
      }
    },
    abrirDialogoAtivarDesativar(status) {
      this.status = status;
      this.$refs.dialogoAtivarDesativar.abrir();
    },
    tooglePesquisa() {
      this.exibirPesquisa = !this.exibirPesquisa;
      if (this.exibirPesquisa) {
        setTimeout(() => {
          this.$refs.pesquisa.focus();
        }, 0);
      }
    },
    tempoAvaliacao(datahora) {
      return moment(new Date(datahora))
        .locale("pt-br")
        .fromNow();
    },
  },
  computed: {
    countAvaliacoes() {
      return this.avaliacoes.length == 0 ? true : false;
    },
  },
};
</script>

<style scoped></style>
